import { Routes } from "@angular/router";
import { protectedRoutePolicy } from "../app-route-access-policy";

// Development, staging, and test configurations in angular.json replace
// development.routes.ts with this file so development pages are excluded from
// all other builds.
export const developmentRoutes: Routes = [
  {
    ...protectedRoutePolicy("dev"),
    loadChildren: () =>
      import("./development.module").then((module) => module.DevelopmentModule),
  },
];
